type AecbConsentClausesProps = {
  clauses: string[];
  className?: string;
};

/** AECB consent wording from the current backend template (LS-618). */
export const AecbConsentClauses = ({
  clauses,
  className = "cx-mt-6 cx-flex cx-flex-col cx-gap-3 cx-text-sm cx-text-text-secondary",
}: AecbConsentClausesProps) => {
  if (!clauses.length) {
    return null;
  }

  return (
    <div className={className}>
      {clauses.map((text) => (
        <p key={text}>{text}</p>
      ))}
    </div>
  );
};
